import React from "react";
import Wordmark from "./Wordmark";

// Anonymous/asynchronous entry into a shared GUESS MY TASTE link (the
// reciprocal "MAKE THEM GUESS YOURS" case). Minimal — the recipient already
// understands KEEP ONE; this only needs to name who and how many rounds.
export default function GuessMyTasteIntro({ targetHandle, totalRounds, onBegin, errored, onRetryHome }) {
  if (errored) {
    return (
      <div className="flex flex-col items-center justify-center h-[100dvh] gap-4 px-8 text-center max-w-[420px] mx-auto">
        <span className="font-display font-bold uppercase tracking-[0.2em] text-sm text-bone">
          This link isn't available
        </span>
        <p className="font-body text-[13px] text-silver leading-relaxed">
          The shared guess link may have expired or been mistyped. You can still start your own Taste Test.
        </p>
        <button data-testid="guess-intro-retry" onClick={onRetryHome}
          className="font-body text-xs tracking-[0.18em] uppercase text-white/60 border border-white/15 rounded-full px-5 py-2.5 hover:text-white">
          Start fresh
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-[100dvh] gap-6 px-8 text-center max-w-[520px] mx-auto" data-testid="guess-intro">
      <Wordmark variant="horizontal" className="h-4" />
      <div className="h-px w-24" style={{ background: "linear-gradient(90deg,var(--tt-left),var(--tt-right))" }} />
      <h1 className="font-display font-black uppercase leading-[1.02] tracking-[-0.02em] text-bone text-4xl sm:text-5xl">
        Guess<br />{targetHandle}'s<br />taste.
      </h1>
      <p className="font-body text-sm text-silver max-w-xs">
        {totalRounds} rounds. Guess what they kept, each time.
      </p>
      <button
        type="button"
        data-testid="guess-intro-begin"
        onClick={onBegin}
        className="mt-2 rounded-full px-10 py-4 font-display font-black uppercase tracking-[0.06em] text-sm text-[#05070a]"
        style={{ background: "linear-gradient(90deg,var(--tt-left),var(--tt-right))" }}
      >
        Start guessing
      </button>
    </div>
  );
}
